import React from "react";

import ParkLineCellContent from "../components/ParkLineCellContent";

import base from "./base";

import { Column, ColumnId } from ".";

function parkLine({ width, onResize }: Column.Options) {
	return base(
		ColumnId.ParkLine,
		(item) => <ParkLineCellContent item={item} />,
		{
			width,

			onResize: onResize as (
				columnWidth?: number | undefined,
				dataKey?: string | undefined,
			) => void,
		},
	);
}

export default parkLine;
